import { CHANGE_DATE_MODE } from '../constants/ActionTypes.js'

export const changeDateMode = mode => ({
  type: CHANGE_DATE_MODE,
  payload: mode,
})